import React, {useContext} from 'react'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTriangleExclamation, faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import {Popover, OverlayTrigger, Button} from 'react-bootstrap';
import { LawyerContext } from './Context';

class Loader extends React.Component {
    render() {
        const {classes} = this.props
        return (
            <div className={`loader ${classes}`}><div className="spinner"></div></div>
        )
    }
}

class Tooltip extends React.Component {
    render() {
        const {text1, text2} = this.props;
        return (
            <div className="sp-tooltip blue tooltip-block bottom tooltip in">
                <div className="tooltip-arrow"></div>
                <div className="tooltip-inner">
                    <div className="icon-wrapper">
                    <FontAwesomeIcon icon={faTriangleExclamation} className='fa-3x fa-triangle'/>
                    </div>
                    <div className="tooltip-text">
                        {text1}<br/>{text2}
                    </div>
                </div>
            </div>
        )
    }
}

class AIWarningTooltip extends React.Component {
    render() {
        const {is_non_test_premium} = this.props;
        var warning, text;
        if (is_non_test_premium) {
            warning="UWAGA:";
            text="Prawniku, propozycja odpowiedzi jest wygenerowana przez sztuczną inteligencję i może być częściowo lub całkowicie niezgodna z aktualnymi przepisami prawa. Przed wysłaniem usuń ją wówczas lub zmodyfikuj jej treść do postaci zgodnej z Twoją wiedzą i doświadczeniem.";
        } else {
            warning="Uwaga:";
            text="Prawniku, jeśli posiadasz nietestowe konto Premium, serwis umożliwia Ci korzystanie z podpowiedzi generowanych przez sztuczną inteligencję, by szybciej i łatwiej odpowiadać klientowi";
        }
        return (
            <div className="sp-tooltip blue tooltip-block bottom tooltip in bottom-buffer">
                <div className="tooltip-arrow"></div>
                <div className="tooltip-inner">
                    <div className="icon-wrapper">
                    <FontAwesomeIcon icon={faTriangleExclamation} className='fa-3x fa-triangle'/>
                    </div>
                    <div className="tooltip-text">
                        <strong>{warning}</strong><br />
                        {text}
                    </div>
                </div>
            </div>
        )
    }
}

class RaspTooltip extends React.Component {
    render() {
        const {rasp} = this.props;
        let link = "https://zapis.specprawnik.pl/bezplatne_pytania_BI";
        if (!rasp) return <></>;
        return (
            <div className="sp-tooltip blue tooltip-block bottom tooltip in bottom-buffer">
                <div className="tooltip-arrow"></div>
                <div className="tooltip-inner">
                    <div className="icon-wrapper">
                    <FontAwesomeIcon icon={faTriangleExclamation} className='fa-3x fa-triangle'/>
                    </div>
                    <div className="tooltip-text">
                        Przygotowując odpowiedzi w ramach RASP, pamiętaj, że treści są wykorzystywane przez dziennikarzy Business Insider Polska w&nbsp;sekcji Prawo. Staraj się udzielać wyczerpujących i&nbsp;merytorycznych odpowiedzi, gdyż mogą one zostać bezpośrednio wykorzystane w&nbsp;artykułach. Dłuższe i&nbsp;bardziej szczegółowe wypowiedzi zwiększają szansę na publikację. Dziennikarze mogą również kontaktować się w&nbsp;celu dalszych wyjaśnień. Więcej informacji: <a href={link}>{link}</a>
                    </div>
                </div>
            </div>
        )
    }
}

class Errors extends React.Component {
    render() {
        const {errors, small} = this.props

        let list = [];
        if (errors.length > 0) {
            errors.map((item, index) => {
            list.push(
                <li key={index}>
                    {small ? <FontAwesomeIcon icon={faTriangleExclamation}/> : ''}
                    {item}
                </li>
            )
            return list
        })
        }
        
        if (errors.length === 0) {
            return null;
        }
        return(
            <div className={`${!small ? 'alert alert-danger error': 'error-small' }`}>
                <ul>
                    {list}
                </ul>
            </div>
        )
    }
}

const PopoverComponent = ({title, text}) => {
      let texts=['Trafiają tu rozmowy z klientem, w których bierzesz udział, a które miały swój początek np. na forum pytań bezpłatnych.', 'Znajdują się tu nowe sprawy kierowane bezpośrednio do Ciebie, ale i pytania od klientów poszukujących prawników do poprowadzenia sprawy.', 'Tu możesz wysłać mail do klienta, którego adres mailowy jest Ci znany i pobrać od niego płatność za usługę.', 'Kody rabatowe to ciąg znaków alfanumerycznych o maksymalnej długości pięciu znaków (np. 12abc), które prawnik może wykorzystać, aby zaoszczędzić na usługach oferowanych przes serwis dla prawników.']
    return(
        <Popover id="popover-basic">
        <Popover.Body>
            <h5>{title}</h5>
            {texts[text]}
    </Popover.Body>
  </Popover>
    )
}

const PopoverInfo = (title, text) => (
  <OverlayTrigger trigger={["hover", 'hover']} placement="top" overlay={PopoverComponent(title, text)
    }>
    <Button className="info-button-circle"><FontAwesomeIcon icon={faInfoCircle} className='fa-info-circle'/></Button>
  </OverlayTrigger>
);

function GetPremium() {
    const lawyer = useContext(LawyerContext);
    const {lawyer_wallet_url} = lawyer;
    return(
        <div>
            <p className="alert alert-danger">Kontakt z klientami dostępny tylko po wykupieniu opcji PREMIUM</p>
            <p><a className="btn btn-primary" href={lawyer_wallet_url}>KUP PREMIUM TERAZ</a></p>
        </div>
    )
}

export {
    Tooltip,
    AIWarningTooltip,
    RaspTooltip,
    Errors,
    Loader,
    GetPremium,
    PopoverInfo, 
}